// extracted by mini-css-extract-plugin
export var dropdown = "_vf-0";
export var imageWrapper = "_vf-3";
export var itemNameContainer = "_vf-1";
export var productImage = "_vf-2";
export var spinnerWrapper = "_vf-4";